import React from 'react';
import { Route } from 'react-router-dom';
import QuickMenu from './views/MainBranch/containers/QuickMenu'
import DashBoard from './views/MainBranch/containers/DashBoard'
import AgentList from './views/MainBranch/containers/AgentsListView'
import Hub_AgentsList from './views/MainBranch/containers/Hub_AgentsListView'

import DeliveryAgentDetails from './views/MainBranch/containers/DeliveryAgentDetails'

import DistrictList from './views/MainBranch/containers/UgDistrictListView'
import AccountList from './views/MainBranch/containers/AccountsListView'
import AccountDetail from './views/MainBranch/containers/AccountDetailView'

import SupplyList from './views/MainBranch/containers/SupplyListView'
import SupplyDetail from './views/MainBranch/containers/SupplyDetailView'

import SampleList from './views/MainBranch/containers/SampleListView'
import SampleDetail from './views/MainBranch/containers/SampleDetailView'

import HubsList from './views/MainBranch/containers/HubsListView'
import HubDetails from './views/MainBranch/containers/HubDetails'

import HealthCenterList from './views/MainBranch/containers/HealthCenterListView'
import Hub_HealthCenterList from './views/MainBranch/containers/Hub_HealthCenterListView'


import HealthCenterDetails from './views/MainBranch/containers/HealthCenterDetails'

import OnlineAgentsList from './views/MainBranch/containers/OnlineAgentsListView'
import ProductList from './views/MainBranch/containers/ProductListView'
import UnitList from './views/MainBranch/containers/ProductUnitListView'
import SupplierList from './views/MainBranch/containers/SupplierListView'
import SupplierDetail from './views/MainBranch/containers/SupplierDetailView'

import OrdersList from './views/MainBranch/containers/OrdersListView'
import CompanyProfile from './views/MainBranch/containers/companyProfile'
import ProductCategoriesList from './views/MainBranch/containers/ProductCategoriesListView'
import ClientList from './views/MainBranch/containers/ClientListView';
import SampleBarCodeForm from './views/MainBranch/components/SampleBarCodeForm';
import RegionList from './views/MainBranch/containers/RegionListView';
import DataImport from './views/MainBranch/components/DataImport';
import AgentFacilityVisitsList from './views/MainBranch/containers/AgentFacilityVisitsListView';

// Import missing operational components
import DeliveriesList from './views/MainBranch/containers/DeliveriesListView';
import HubDeliveriesList from './views/MainBranch/containers/Hub_DeliveriesListView';
import PendingPickupsList from './views/MainBranch/containers/PendingUmojaPickupsList';
import HubOnlineAgentsList from './views/MainBranch/containers/Hub_OnlineAgentsListView';
import AgentActivityMap from './views/MainBranch/containers/AgentActivityMap';
import HubAgentActivityMap from './views/MainBranch/containers/Hub_AgentActivityMap';
import GraphsComponent from './views/MainBranch/containers/GraphsComponent';
import GraphsComponentHub from './views/MainBranch/containers/GraphsComponentHub';
import AuditLogViewer from './views/MainBranch/containers/AuditLogViewer';
import LIMSIntegration from './views/LIMSIntegration';
import PatientManagementView from './views/MainBranch/containers/PatientManagementView';


const SaccoBaseRouter = () =>(

     <div>
        <Route exact path='/' component={DashBoard} />
        <Route exact path='/quickmenu/' component={QuickMenu} />
        <Route exact path='/deliveryagents/' component={AgentList} />
        <Route exact path='/hub_deliveryagents/' component={Hub_AgentsList} />

        <Route exact path='/deliveryagents/:agentID' component={DeliveryAgentDetails} />

        <Route exact path='/districts/' component={DistrictList}  />
        <Route exact path='/useraccounts/' component={AccountList} />
        <Route exact path='/useraccounts/:accountID' component={AccountDetail} />

        <Route exact path='/supplies/' component={SupplyList} />
        <Route exact path='/supplies/:supplyID' component={SupplyDetail} />

        <Route exact path='/samples/' component={SampleList} />
        <Route exact path='/samples/:sampleID' component={SampleDetail} />

        <Route exact path='/collectionhubs/' component={HubsList} />
        <Route exact path='/collectionhubs/:hubID' component={HubDetails} />

        <Route exact path='/healthcenters/' component={HealthCenterList} />
        <Route exact path='/hub_healthcenters/' component={Hub_HealthCenterList} />

        <Route exact path='/healthcenters/:centerID' component={HealthCenterDetails} />

        <Route exact path='/products/' component={ProductList} />
        <Route exact path='/product_units/' component={UnitList} />
        <Route exact path='/product_categories/' component={ProductCategoriesList} />

        <Route exact path='/suppliers/' component={SupplierList} />
        <Route exact path='/supplierdetails/:supplierID' component={SupplierDetail} />

        <Route exact path='/orders/' component={OrdersList} />
        <Route exact path='/companyprofile/' component={CompanyProfile} />
        <Route exact path='/app_clients/' component={ClientList} />

        <Route exact path='/bar_codes/' component={SampleBarCodeForm} />
        <Route exact path='/regions/' component={RegionList} />

        <Route exact path='/data_import_export/' component={DataImport} />
        <Route exact path='/facility_visits/' component={AgentFacilityVisitsList} />

        {/* Operational Routes */}
        <Route exact path='/deliveries/' component={DeliveriesList} />
        <Route exact path='/hub_deliveries/' component={HubDeliveriesList} />
        <Route exact path='/pending_pickups/' component={PendingPickupsList} />
        <Route exact path='/patient_management/' component={PatientManagementView} />
        <Route exact path='/online_agents/' component={OnlineAgentsList} />
        <Route exact path='/hub_online_agents/' component={HubOnlineAgentsList} />
        
        {/* Reports & Analytics Routes */}
        <Route exact path='/agent_activity_map/' component={AgentActivityMap} />
        <Route exact path='/hub_agent_activity_map/' component={HubAgentActivityMap} />
        <Route exact path='/analytics_graphs/' component={GraphsComponent} />
        <Route exact path='/hub_analytics_graphs/' component={GraphsComponentHub} />
        
        {/* LIMS Integration Routes - Branch Manager Only */}
        <Route exact path='/lims_integration/' component={LIMSIntegration} />
        
        {/* System Routes */}
        <Route exact path='/audit_logs/' component={AuditLogViewer} />

    </div>
);

export default SaccoBaseRouter;


